import { render } from "./Login_Btn.vue?vue&type=template&id=0ca7ad30"
import script from "./Login_Btn.vue?vue&type=script&lang=js"
export * from "./Login_Btn.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__